import React, { useContext } from 'react';
import { ELSPageLoader } from '@els/els-ui-common-react';
import { AppContext } from '../app/AppProvider.component';
import IsRender from '../is-render/IsRender.component';

const LaunchingRecommendationLoader = (): JSX.Element => {
  const { appState } = useContext(AppContext);

  return (
    <IsRender isRender={appState.isLaunchingRecommendation}>
      <ELSPageLoader />
    </IsRender>
  );
};

export default LaunchingRecommendationLoader;
